<template>
  <div
    class="mx-4 flex h-[100px] justify-center border-b border-gray-200 py-4 md:mx-6 md:h-[120px] md:py-6"
  >
    <AppBrand class="h-full" height="32" variant="white" />
  </div>
</template>
